import { Adapter as o } from "../../../adapter.js";
import { TicketItemPromotionModel as r } from "./ticketItemPromotion.model.js";
class n extends o {
  adapt(e) {
    return new r(
      {
        generatedId: e.generated_id,
        code: e.code,
        name: e.name,
        value: e.value,
        promotionType: e.promotion_type
      }
    );
  }
  serialize(e) {
  }
}
export {
  n as TicketItemPromotionAdapter
};
//# sourceMappingURL=ticketItemPromotion.adapter.js.map
